import React from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import { Container, Row, Col, Card, Button } from "react-bootstrap";
import { BrowserRouter as Router, Routes, Route, Link } from "react-router-dom";
import "./adminhome.css";

function AdminHome() {
  return (
    <div className="container container-fluid login-conatiner">
      <div style={{ padding: "5px" }}>
        <div className="d-flex flex-row btn btn-dark btn-lg btn-block">
          <h3 style={{ color: "white", marginLeft: "530px" }}>ADMIN</h3>
          <Link style={{ color: "white", marginLeft: "540px" }} to="/logout">
            <Button variant="secondary">Logout</Button>
          </Link>{" "}
        </div>
      </div>
      <div style = {{textAlign:"center"}}>
      <Container style={{ paddingTop: "100px" }}>
        <Row>
          <Col sm>
            <Card className="inner-prop" style={{ borderRadius: "25px" }}>
              <Card.Img
                style={{
                  width: 286,
                  height: 160,
                  borderRadius: "25px",
                  marginLeft: "8px",
                }}
                variant="top"
                src="https://image.shutterstock.com/image-vector/modern-thin-line-flat-design-260nw-1292466061.jpg"
              />
              <Card.Body>
                <Card.Title>Resources</Card.Title>
                <Card.Text>
                View the supply chain of resources and perform required transactions
                </Card.Text>

                <Link to="/admin/resources">
                  <Button
                    className="btn btn-dark btn-lg btn-block"
                    variant="primary"
                  >
                    Supply Chain
                  </Button>
                </Link>
              </Card.Body>
            </Card>
          </Col>

          <Col sm>
            <Card className="inner-prop" style={{ borderRadius: "25px" }}>
              <Card.Img
                style={{
                  width: 286,
                  height: 160,
                  borderRadius: "25px",
                  marginLeft: "8px",
                }}
                variant="top"
                src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRvn1uYhlehYt1O51oW41l_it3umvhi_n3_oQ&usqp=CAU"
              />
              <Card.Body>
                <Card.Title>Insurance</Card.Title>
                <Card.Text>
                  Check the list of all insurance claims
                  and sign them accordingly
                </Card.Text>
                <Link to="/admin/insurance">
                  
                  <Button
                    className="btn btn-dark btn-lg btn-block"
                    variant="primary" 
                  >
                    Sign Claim
                  </Button>
                  
                </Link>{" "}
              </Card.Body>
            </Card>
          </Col>
          <Col sm>
            <Card className="inner-prop" style={{ borderRadius: "25px" }}>
              <Card.Img
                style={{
                  width: 286,
                  height: 160,
                  borderRadius: "25px",
                  marginLeft: "8px",
                }}
                variant="top"
                src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTTzGfL87G917Q1wFaBVMFMtE7J4SXfdBem2Q&usqp=CAU"
              />
              <Card.Body>
                <Card.Title>Notifications</Card.Title>
                <Card.Text>
                 Create a new notification regarding the number of resources
                 in a hospital 
                </Card.Text>
                <Link to="/admin/notif">
                  <Button
                    className="btn btn-dark btn-lg btn-block"
                    variant="primary"
                  >
                    Make Notice
                  </Button>
                </Link>{" "}
              </Card.Body>
            </Card>
          </Col>
        </Row>
      </Container>
      </div>
    </div>
  );
}

export default AdminHome;
